import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
// import { Media } from "react-bootstrap";
// import DataTable from "react-data-table-component";
// import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import $ from "jquery";
import PropTypes from 'prop-types';
import Select from "react-select";

import { loader_image } from "../_components/Imagepath";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { base_url, Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from 'material-react-table';
import Swal from 'sweetalert2'; import bwipjs from 'bwip-js';
import {

  MenuItem,
} from '@mui/material';
const ProductionOutput = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [datafinished, setDatafinished] = useState([]);
  const [datasemifinished, setDatasemifinished] = useState([]);

  const [dataaa, setDataaa] = useState([]);
  const [groupproductLists, setGroupproductLists] = useState([]);

  const [locationLoading, setLocationLoading] = useState([]);
  const [permission, setPermission] = useState({});

  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  // const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 50 });
  // const [sorting, setSorting] = useState([]);
  // const [columnFilters, setColumnFilters] = useState([]);
  const [isLoadingimg, setIsLoadingimg] = useState(false);




  const topScrollRef = useRef(null);
  const tableContainerRef = useRef(null);

  const topScrollFinishedRef = useRef(null);
  const tableContainerFinishedRef = useRef(null);

  const topScrollSemiRef = useRef(null);
  const tableContainerSemiRef = useRef(null);



  const [pagination, setPagination] = useState(() => {
    const savedPagination = localStorage.getItem('tablePagination');
    return savedPagination ? JSON.parse(savedPagination) : { pageIndex: 0, pageSize: 50 };
  });

  const [sorting, setSorting] = useState(() => {
    const savedSorting = localStorage.getItem('tableSorting');
    return savedSorting ? JSON.parse(savedSorting) : [];
  });

  const [columnFilters, setColumnFilters] = useState(() => {
    const savedFilters = localStorage.getItem('tableColumnFilters');
    return savedFilters ? JSON.parse(savedFilters) : [];
  });
  // Save table state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('tablePagination', JSON.stringify(pagination));
  }, [pagination]);

  useEffect(() => {
    localStorage.setItem('tableSorting', JSON.stringify(sorting));
  }, [sorting]);

  useEffect(() => {
    localStorage.setItem('tableColumnFilters', JSON.stringify(columnFilters));
  }, [columnFilters]);


  const shiftlist = [
    { value: 1, label: "Shift 1" },
    { value: 2, label: "Shift 2" }
  ];

  const fetchProductionsOutputData = async () => {
    setLoading(true);
    try {
      const response = await axios
        .post("/production-output/fetchProductionsOutputDataPagination", formData, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          params: {
            page: pagination.pageIndex + 1,
            pageSize: pagination.pageSize,
            filters: columnFilters, // Send multi-column filters
            sorting: sorting.map(({ id, desc }) => ({
              column: id,
              order: desc ? "desc" : "asc",
            })),
          },
        });

      console.log(response.data.data.data);
      setData(response.data.data.data);
      setTotalRows(response.data.total);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  console.log(dataaa);
  const fetchProductionsOutputDataAll = async () => {
    setLoading(true);
    try {
      const response = await axios
        .post("/production-output/fetchProductionsOutputDatafinished", formData, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },

        });

      setDatafinished(response.data.data.productions);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };
  const fetchProductionsOutputDataAllSemi = async () => {
    setLoading(true);
    try {
      const response = await axios
        .post("/production-output/fetchProductionsOutputDataSemifinished", formData, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },

        });

      setDatasemifinished(response.data.data.productions);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };



  useEffect(() => {
    fetchProductionsOutputData();
  }, [pagination, sorting, columnFilters]); // Fetch when any filter/sort/pagination changes




  const [formData, setFormData] = useState({
    shift: '',
    start_date: '',
    end_date: ''
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  console.log(formData);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(e);
    setLoading(true);
    try {
      axios.post("/production-output/fetchProductionsOutputDataPagination", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        params: {
          page: pagination.pageIndex + 1,
          pageSize: pagination.pageSize,
          filters: columnFilters, // Send multi-column filters
          sorting: sorting.map(({ id, desc }) => ({
            column: id,
            order: desc ? "desc" : "asc",
          })),
        },
      }).then((response) => {
        console.log(response.data.data.data);
        setData(response.data.data.data);
        setTotalRows(response.data.total);
      })


    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);

    try {
      axios.post("/production-output/fetchProductionsOutputDataSemifinished", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        setDatasemifinished(response.data.data.productions);
      });


    } catch (error) {
      console.error("Error fetching data:", error);
    }

    try {
      axios.post("/production-output/fetchProductionsOutputDatafinished", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        setDatafinished(response.data.data.productions);
      });

    } catch (error) {
      console.error("Error fetching data:", error);
    }

        try {
      const response = axios.post("/production-output/fetchGroupByShiftDateData", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      });
      if (response.data.code === 200) {
        setDataa(response.data.data.productions_groupby);
      } else {
        window.location.href = "/login";
      }
    } catch (error) {
      console.error(error);
    }

  }
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    console.log(Input_name);
    // delete backendErrors[Input_name];
  };
  useEffect(() => {
    setPermission(FindModuleById(51));


    axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code == 200) {
          let locations = response.data.data.locations;
          let emp_statusList = locations.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `sts-${index}`,
          }));


          setLocationLoading(emp_statusList);



        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios.post("/products/listing-groupby", {}, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if (response.data.code === 200) {
        let farmers = response.data.data.products;
        let productslisting = farmers.map((customer, index) => ({
          label: customer.name,
          value: customer.name,
          symbol: customer.symbol,
          key: `product-${index}`
        }));
        setGroupproductLists(productslisting);
      } else {
        console.log("API response is not an array");
      }
    })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/production-output/delete/${item}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                window.location.href = "/production-output";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }



  const editItem = (item) => {
    window.location.href = "/production-output-edit/" + item;
  }

  const printPalletLabel = (item) => {
    var id = item.id;
    setIsLoadingimg(true);

    $("#loader-image2").removeClass('loader-hide');
    $("#loader-image2").addClass('loader-show');
    axios.get(`/production-output/pdf/${id}`, {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
    }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      let file_name = 'Pallet Label - ' + item.barcode_number + '.pdf';
      link.download = file_name;
      link.click();
    })
      .catch(error => {
        console.error('Error downloading PDF:', error);
      }).finally(() => {
        setIsLoadingimg(false);
      });

  }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  // BarcodeNumberCell Component
  const BarcodeNumberCell = ({ row }) => (
    <a href={`/production-output-view/${row.original.id}`}>
      {row.original.barcode_number}
    </a>
  );




  // ✅ PropTypes validation
  BarcodeNumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        barcode_number: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };


  const columnsother = [
    {
      header: 'Barcode Number',
      accessorFn: (row) => row.barcode_number,
      Cell: BarcodeNumberCell,
    },
    {
      accessorKey: "toal_lot_number",
      header: "Lot Number",
    },
    {
      accessorKey: 'supplier_name', //normal accessorKey
      header: 'Supplier',
    },
    {
      accessorKey: 'prodcut_name', //normal accessorKey
      header: 'Product',
    },

    {
      accessorKey: 'total_output_type', //normal accessorKey
      header: 'Output Type',
    },


    { accessorKey: 'date_time', header: 'Date Time' },
    { accessorKey: 'shift', header: 'Shift' },
    { accessorKey: 'shift_date', header: 'Shift Date' },
    //  {
    //     accessorKey: 'total_net_weight', //normal accessorKey
    //     header: 'Net Weight',
    //   },
    {
      header: 'Net Weight',
      accessorFn: (row) => {
        const netWeight = row.total_net_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
    {
      accessorKey: 'total_number_of_boxes', //normal accessorKey
      header: 'Number Of Boxes',
    },
    {
      accessorKey: 'packaging_name', //normal accessorKey
      header: 'Package Type',
    },
    {
      header: 'Location',
      accessorFn: (row) =>
        row.location_name
          ? `${row.location_name.title} `
          : '',
    },

    {
      header: 'Created By',
      accessorFn: (row) =>
        row.createdby
          ? `${row.createdby.first_name} ${row.createdby.last_name}`
          : '',
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        row.updatedby
          ? `${row.updatedby.first_name} ${row.updatedby.last_name}`
          : '',
    },
  ];


  const columns = [
    {
      header: 'Barcode Number',
      accessorFn: (row) => row.barcode_number,
      Cell: BarcodeNumberCell,
    },
    {
      accessorKey: "toal_lot_number",
      header: "Lot Number",
    },

    {
      accessorKey: 'supplier_name', //normal accessorKey
      header: 'Supplier',
    },
    {
      accessorKey: 'prodcut_name', //normal accessorKey
      header: 'Product',
    },

    {
      accessorKey: 'total_output_type', //normal accessorKey
      header: 'Output Type',
    },


    { accessorKey: 'date_time', header: 'Date Time' },
    { accessorKey: 'shift', header: 'Shift' },
    { accessorKey: 'shift_date', header: 'Shift Date' },
    //  {
    //     accessorKey: 'total_net_weight', //normal accessorKey
    //     header: 'Net Weight',
    //   },
    {
      header: 'Net Weight',
      accessorFn: (row) => {
        const netWeight = row.total_net_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
    {
      accessorKey: 'total_number_of_boxes', //normal accessorKey
      header: 'Number Of Boxes',
    },
    {
      accessorKey: 'packaging_name', //normal accessorKey
      header: 'Package Type',
    },
    {
      accessorKey: 'location_name', //normal accessorKey
      header: 'Location',
    },

    {
      header: 'Created By',
      accessorFn: (row) =>
        row.createdby
          ? `${row.createdby.first_name} ${row.createdby.last_name}`
          : '',
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        row.updatedby
          ? `${row.updatedby.first_name} ${row.updatedby.last_name}`
          : '',
    },
  ];


  const ShiftDateCell = ({ row }) => (
    <a href={`/production-output-groupby/${row.original.shift_date}_${row.original.location}`}>
      {row.original.shift_date}
    </a>
  );

  const LocationCell = ({ row }) => (
    <a href={`/production-output-groupby/${row.original.shift_date}_${row.original.location}`}>
      {row.original.location_name ? row.original.location_name.title : ""}
    </a>
  );

  // ✅ Add PropTypes validation
  ShiftDateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string.isRequired,
        location: PropTypes.string,
        // shift: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };

  LocationCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string.isRequired,
        location: PropTypes.string,
        // shift: PropTypes.string.isRequired,
        location_name: PropTypes.shape({
          title: PropTypes.string,
        }),
      }).isRequired,
    }).isRequired,
  };

  const columnss = [
    {
      header: 'Shift Date',
      accessorFn: (row) => `${row.shift_date} `,
      Cell: ShiftDateCell,
    },
    {
      header: 'Location',
      accessorFn: (row) => `${row.location_name ? row.location_name.title : ""} `,
      Cell: LocationCell,
    },
    //    {
    //   accessorKey: 'total_net_weight', 
    //   header: 'Total Net Weight',
    // },
    {
      header: 'Total Net Weight',
      accessorFn: (row) => {
        const netWeight = row.total_net_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
    {
      accessorKey: 'total_boxes',
      header: 'Total Boxes',
    },
  ];





  // Product link component
  const ProductGroup = ({ row }) => (
    <a href={`/production-output-pallettype/${row.original.product}_${row.original.location}`}>
      {row.original.product_title ?? ""}
    </a>
  );

  ProductGroup.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        product: PropTypes.string.isRequired,
        location: PropTypes.string,
        product_title: PropTypes.string,
      }).isRequired,
    }).isRequired,
  };

  // Location link component
  const LocationGroup = ({ row }) => (
    <a href={`/production-output-pallettype/${row.original.product}_${row.original.location}`}>
      {row.original.location_name ?? ""}
    </a>
  );

  LocationGroup.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        product: PropTypes.string.isRequired,
        location: PropTypes.string,
        location_name: PropTypes.string,
      }).isRequired,
    }).isRequired,
  };

  console.log(permission);

  function objectToQueryString(obj) {
    return Object.keys(obj)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
      .join('&');
  }
  const downloadExcel = (e) => {


    console.log(e);
    const queryString = objectToQueryString(formData);


    console.log(queryString);

    window.open(`${base_url}/production-output/listing-excel?${queryString}`, '_blank');

  }

  useEffect(() => {

    // Attach an event listener for tab change
    const tabElements = document.querySelectorAll('[data-bs-toggle="tab"]');
    tabElements.forEach((tab) => {
      tab.addEventListener('shown.bs.tab', (event) => {
        const tabName = event.target.getAttribute('href').replace('#listing-', '');
        handleTabChange(tabName);
      });
    });

    // Cleanup on component unmount
    return () => {
      tabElements.forEach((tab) => {
        tab.removeEventListener('shown.bs.tab', () => { });
      });
    };
  }, []);
  const handleTabChange = (tabName) => {
    console.log(`Tab changed to: ${tabName}`);
    switch (tabName) {
      case 'groupByShiftDate':
        fetchGroupByShiftDateData(); // Example function
        break;
      case 'groupByPalletType':
        fetchGroupByPalletTypeData(); // Example function
        break;
      case 'productionsOutput':
        fetchProductionsOutputData(); // Example function
        break;
      case 'finishedproductionsOutput':
        fetchProductionsOutputDataAll(); // Example function fetchProductionsOutputDataAllSemi
        break;
      case 'semiproductionsOutput':
        fetchProductionsOutputDataAllSemi(); // Example function 
        break;
      default:
        break;
    }
  };
  const fetchGroupByShiftDateData = async () => {
    console.log('Fetching data for Group By Shift Date');

    try {
      const response = await axios.post("/production-output/fetchGroupByShiftDateData", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      });
      if (response.data.code === 200) {
        setDataa(response.data.data.productions_groupby);
      } else {
        window.location.href = "/login";
      }
    } catch (error) {
      console.error(error);
    }


  };

  const fetchGroupByPalletTypeData = async () => {
    console.log('Fetching data for Group By Pallet Type');

    try {
      const response = await axios.post("/production-output/fetchGroupByPalletTypeData", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      });
      if (response.data.code === 200) {
        setDataaa(response.data.data.reports_pallet_types);
      } else {
        window.location.href = "/login";
      }
    } catch (error) {
      console.error(error);
    }

  };



  const syncScrollbar = (topScrollRef, containerSelector, data) => {
    console.log(data);
    const tableContainer = document.querySelector(containerSelector + ' .MuiTableContainer-root');
    const topScroll = topScrollRef.current;
    const topScrollContent = topScroll?.querySelector('.top-scroll-content');

    if (tableContainer && topScroll && topScrollContent) {
      topScrollContent.style.width = `${tableContainer.scrollWidth}px`;

      const handleTopScroll = () => { tableContainer.scrollLeft = topScroll.scrollLeft; };
      const handleTableScroll = () => { topScroll.scrollLeft = tableContainer.scrollLeft; };

      topScroll.addEventListener('scroll', handleTopScroll);
      tableContainer.addEventListener('scroll', handleTableScroll);

      return () => {
        topScroll.removeEventListener('scroll', handleTopScroll);
        tableContainer.removeEventListener('scroll', handleTableScroll);
      };
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      syncScrollbar(topScrollRef, '.production-output-listing', data);
    }, 100);
    return () => clearTimeout(timer);
  }, [data]);

  useEffect(() => {
    const timer = setTimeout(() => {
      syncScrollbar(topScrollFinishedRef, '.production-finished-listing', datafinished);
    }, 100);
    return () => clearTimeout(timer);
  }, [datafinished]);

  useEffect(() => {
    const timer = setTimeout(() => {
      syncScrollbar(topScrollSemiRef, '.production-semi-listing', datasemifinished);
    }, 100);
    return () => clearTimeout(timer);
  }, [datasemifinished]);


  const handleSelectChangeLocation = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, location: selectedOption.value });
  };
  const handleSelectChangeShift = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, shift: selectedOption.value });
  };

  const handleSelectChangeProduct = (selectedOption) => {
    console.log(selectedOption);
    setFormData({ ...formData, product: selectedOption.value });
  };


  /**
   * ✅ bwip-js renders onto a hidden <canvas>, then exports to PNG base64.
   * 100% synchronous — no React rendering, no setTimeout needed.
   * bwip-js is the industry-standard engine used in warehouse/logistics systems.
   * scale:4 ensures crisp bars that scan instantly even on low-quality scanners.
   */
  const generateBarcodeDataURL = (barcodeValue) => {
    try {
      const canvas = document.createElement('canvas');
      bwipjs.toCanvas(canvas, {
        bcid: 'code128',          // CODE128 — best for alphanumeric data
        text: barcodeValue,
        scale: 4,                 // scale 4 = crisp bars (higher = better scan quality)
        height: 20,               // bar height in mm (20mm = standard warehouse label)
        includetext: true,        // show human-readable number below bars
        textxalign: 'center',
        textsize: 14,
        paddingwidth: 10,         // quiet zone left/right — critical for scanning!
        paddingheight: 5,         // quiet zone top/bottom
        backgroundcolor: 'ffffff',
        barcolor: '000000',
      });
      return canvas.toDataURL('image/png');
    } catch (err) {
      console.error('bwip-js barcode generation failed:', err);
      return '';
    }
  };

  const handleSemiFinishedClick = (id) => {
    axios.get(`/production-output/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        if (response.data.code === 200) {
          const barcode_data = response.data.data.production;
          const originalBarcodeNumber = barcode_data.barcode_number;
          const barcodeDataURL = generateBarcodeDataURL(originalBarcodeNumber);
          let get_contents = '';
          get_contents += '<div id="div-print" style="padding: 5px;">';
          get_contents += '<div style="text-align: center; margin-bottom: 10px;">';
          get_contents += '<h3 style="font-size: 36px; margin-bottom: 10px;">Semi Finished Output Details</h3>';
          get_contents += '<hr style="border: 2px solid #000; margin: 20px 0;">';
          get_contents += '</div>';
          get_contents += '<table style="width:100%; border-collapse: collapse; margin-bottom: 10px;">';
          get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5; width: 35%;">Barcode#</td>';
          get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + originalBarcodeNumber + '</td></tr>';

          get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Date And Time</td>';
          get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.date_time || '') + '</td></tr>';

          get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Shift Date</td>';
          get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.shift_date || '') + '</td></tr>';

          get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Shift</td>';
          get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.shift || '') + '</td></tr>';

          get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Location</td>';
          get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.location_name ? barcode_data.location_name.title : '') + '</td></tr>';

          get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Package Type</td>';
          get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + (barcode_data.packaging_name || '') + '</td></tr>';

          get_contents += '<tr><td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: bold; background-color: #f5f5f5;">Lot Number</td>';
          get_contents += '<td style="font-size: 24px; font-family: monospace; padding: 8px; border: 1px solid #000; font-weight: 600;">' + barcode_data.toal_lot_number + '</td></tr>';

          get_contents += '</table><br/>';

          get_contents += '<h5 style="font-size: 24px; margin: 10px 0; text-align: left;">Items Details</h5>';
          get_contents += '<table style="width:100%; border-collapse: collapse; margin-bottom: 10px;">';
          get_contents += '<thead>';
          get_contents += '<tr style="background-color: #f5f5f5;">';
          get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Product</th>';
          get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Number Of Boxes</th>';
          get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Gross Weight (KG)</th>';
          get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Boxes weight (KG)</th>';
          get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Pallets Weight (KG)</th>';
          get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Net Weight (KG)</th>';
          get_contents += '<th style="padding: 5px; border: 2px solid #000; font-size: 18px; font-weight: bold;">Output Type</th>';
          get_contents += '</tr>';
          get_contents += '</thead><tbody>';

          if (barcode_data.contents && Array.isArray(barcode_data.contents)) {
            barcode_data.contents.forEach((item, index) => {
              const rowBgColor = index % 2 === 0 ? '#ffffff' : '#f9f9f9';
              get_contents += `<tr style="background-color: ${rowBgColor};">`;
              get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${item.product_name || ''}</td>`;
              get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${item.number_of_boxes || ''}</td>`;

              const grossWeight = typeof item.gross_weight === 'number' ? item.gross_weight.toFixed(2) : '0';
              get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${grossWeight}</td>`;

              const boxWeight = typeof item.box_weight === 'number' ? item.box_weight.toFixed(2) : '0';
              get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${boxWeight}</td>`;

              const palletWeight = typeof item.pallet_weight === 'number' ? item.pallet_weight.toFixed(2) : '0';
              get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${palletWeight}</td>`;

              const netWeight = typeof item.net_weight === 'number' ? item.net_weight.toFixed(2) : '0';
              get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${netWeight}</td>`;

              const outputTypeLabel = item?.output_type === 1 ? 'Finished' : 'Semi Finished';
              get_contents += `<td style="padding: 8px; border: 1px solid #000; font-size: 18px;">${outputTypeLabel}</td>`;
              get_contents += '</tr>';
            });
          }

          get_contents += '</tbody></table><br/>';

          // ✅ Embed as PNG <img> — base64 inline, loads instantly, no external requests
          get_contents += '<div style="text-align: center; margin-top: 30px;">';
          if (barcodeDataURL) {
            get_contents += `<img src="${barcodeDataURL}" alt="Barcode: ${originalBarcodeNumber}" style="max-width: 60%; height: auto; display: block; margin: 0 auto;" />`;
          }
          get_contents += '</div>';
          get_contents += '</div>';

          const width = 500;
          const height = 600;
          const widthInPixels = width * 3.779527559;
          const heightInPixels = height * 3.779527559;
          const left = (window.screen.width - widthInPixels) / 2;
          const top = (window.screen.height - heightInPixels) / 2;
          const windowFeatures = `width=${widthInPixels},height=${heightInPixels},left=${left},top=${top}`;

          const printWindow = window.open('', '', windowFeatures);
          printWindow.document.open();
          printWindow.document.write(`<html>
          <head>
            <title>Production Output - ${originalBarcodeNumber}</title>
            <style>
              @media print {
                body { margin: 0; padding: 20px; }
              }
              table { page-break-inside: avoid; }
              tr { page-break-inside: avoid; page-break-after: avoid; }
              img { display: block; margin: 0 auto; }
            </style>
          </head>
          <body style="font-family: Arial, sans-serif; margin: 0; padding: 20px;">
            ${get_contents}
          </body>
        </html>`);
          printWindow.document.close();

          // ✅ onload fires after full paint — eliminates all timing/delay issues
          printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          };
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Production Output</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Production Output
                    </li>
                  </ul>
                </div>
                <div className="col-auto">
                  {permission && permission.add === 1 && (
                    <Link to="/production-output-add" className="btn btn-primary me-1">
                      <i className="fas fa-plus"></i>
                    </Link>
                  )}
                  &nbsp;&nbsp;

                  {permission && permission.list === 1 && (
                    <button
                      className="btn btn-primary"
                      onClick={() => downloadExcel()}
                    >
                      <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image} />
                    </button>
                  )}

                </div>
              </div>


            </div>

            <div id="filter_inputs" className="card filter-card2">
              <div className="card-body p-10">
                <form onSubmit={handleSubmit}>
                  <div className="row">



                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Start Date:</label>
                        <input type="date" name="start_date" className="form-control" value={formData.start_date} onChange={(e) => {
                          handleChange(e);
                          customHandleInput(e);
                        }} />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>End Date:</label>
                        <input type="date" name="end_date" className="form-control" value={formData.end_date} onChange={(e) => {
                          handleChange(e);
                          customHandleInput(e);
                        }} />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Location:</label>

                        <Select

                          options={locationLoading}
                          name="location"
                          value={locationLoading.find(option => option.value === formData.location) || null}
                          onChange={(selectedOption) => handleSelectChangeLocation(selectedOption)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Select Shift</label>
                        <Select
                          className="w-100"
                          value={shiftlist.find(option => option.value === formData.shift) || null}
                          name="shift"
                          onChange={(selectedOption) => handleSelectChangeShift(selectedOption)}
                          options={shiftlist}
                          placeholder="Select"
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Select Product</label>
                        <Select
                          className="w-100"
                          value={groupproductLists.find(option => option.value === formData.product) || null}
                          name="shift"
                          onChange={(selectedOption) => handleSelectChangeProduct(selectedOption)}
                          options={groupproductLists}
                          placeholder="Select"
                        />
                      </div>
                    </div>


                    <div className="col-md-2">
                      <div className="pt-4 mt-2">
                        <button type="submit" className="btn btn-primary">
                          Filter
                        </button>
                        &nbsp;&nbsp;
                        <a href="/production-output" className="btn btn-primary me-1"><i className="fa fa-times"></i></a>

                      </div>
                    </div>
                  </div>
                </form>

              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <section className="comp-section">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card bg-white">
                        {permission && permission.list === 1 && (
                          <div className="card-body">
                            <ul className="nav nav-tabs nav-tabs-bottom">

                              <li className="nav-item">
                                <a className="nav-link " href="#listing-groupby" data-bs-toggle="tab" onClick={() => handleTabChange('groupByShiftDate')}
                                >Group By Shift Date And Location</a>
                              </li>


                              <li className="nav-item">
                                <a className="nav-link active" href="#listing-all" data-bs-toggle="tab" onClick={() => handleTabChange('productionsOutput')}
                                > Productions Output</a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link" href="#listing-all-finished" data-bs-toggle="tab" onClick={() => handleTabChange('finishedproductionsOutput')}
                                > Finished Productions Output</a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link" href="#listing-all-semi" data-bs-toggle="tab" onClick={() => handleTabChange('semiproductionsOutput')}
                                > Semi Finished Productions Output</a>
                              </li>
                            </ul>

                            <div className="tab-content">
                              <div className="tab-pane" id="listing-groupby">
                                <div className="row" id="listing-followup-groupby" >
                                  <div className="col-sm-12" >
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <MaterialReactTable columns={columnss} data={dataa}
                                            enableColumnOrdering
                                            enablePinning
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="tab-pane " id="listing-all-finished">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          {/* ✅ Top scrollbar */}
                                          <div
                                            ref={topScrollFinishedRef}
                                            className="top-scrollbar"
                                            style={{ overflowX: 'auto', overflowY: 'hidden', marginBottom: '10px', height: '90px' }}
                                          >
                                            <div className="top-scroll-content" style={{ height: '1px' }}></div>
                                          </div>
                                          <div className="table-responsive production-finished-listing" ref={tableContainerFinishedRef}>
                                            <MaterialReactTable columns={columnsother} data={datafinished}
                                              enableColumnOrdering
                                              enablePinning
                                              enableRowActions={true}
                                              renderRowActionMenuItems={({ row }) => [
                                                permission?.list === 1 && row.original.total_output_type === 'Finished' && (
                                                  <MenuItem key="view1" onClick={() => printPalletLabel(row.original)}>
                                                    Print Pallet Label

                                                    {isLoadingimg && (
                                                      <img
                                                        id="loader-image2"
                                                        className="loader-image loader-hide"
                                                        src={loader_image}
                                                        alt="Loading"
                                                      />
                                                    )}
                                                  </MenuItem>
                                                ),

                                                permission?.list === 1 && row.original.total_output_type === 'Semi Finished' && (
                                                  <MenuItem key="view2" onClick={() => handleSemiFinishedClick(row.original.id)}>
                                                    Print Pallet Label
                                                  </MenuItem>
                                                ),
                                                permission?.update === 1 && (
                                                  <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                    Edit
                                                  </MenuItem>
                                                ),
                                                permission?.delete === 1 && (
                                                  <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                    Delete
                                                  </MenuItem>
                                                ),
                                              ]}

                                            />
                                          </div>


                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="tab-pane " id="listing-all-semi">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <div
                                            ref={topScrollSemiRef}
                                            className="top-scrollbar"
                                            style={{ overflowX: 'auto', overflowY: 'hidden', marginBottom: '10px', height: '90px' }}
                                          >
                                            <div className="top-scroll-content" style={{ height: '1px' }}></div>
                                          </div>
                                          <div className="table-responsive production-semi-listing" ref={tableContainerSemiRef}>
                                            <MaterialReactTable columns={columnsother} data={datasemifinished}
                                              enableColumnOrdering
                                              enablePinning={true}
                                              enableRowActions={true}
                                              renderRowActionMenuItems={({ row }) => [
                                                permission?.list === 1 && row.original.total_output_type === 'Finished' && (
                                                  <MenuItem key="view1" onClick={() => printPalletLabel(row.original)}>
                                                    Print Pallet Label

                                                    {isLoadingimg && (
                                                      <img
                                                        id="loader-image2"
                                                        className="loader-image loader-hide"
                                                        src={loader_image}
                                                        alt="Loading"
                                                      />
                                                    )}
                                                  </MenuItem>
                                                ),

                                                permission?.list === 1 && row.original.total_output_type === 'Semi Finished' && (
                                                  <MenuItem key="view2" onClick={() => handleSemiFinishedClick(row.original.id)}>
                                                    Print Pallet Label
                                                  </MenuItem>
                                                ),
                                                permission?.update === 1 && (
                                                  <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                    Edit
                                                  </MenuItem>
                                                ),
                                                permission?.delete === 1 && (
                                                  <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                    Delete
                                                  </MenuItem>
                                                ),
                                              ]}

                                            />
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>


                              <div className="tab-pane  show active" id="listing-all">
                                <div className="row" id="listing-followup">
                                  <div className="col-sm-12">
                                    <div className="card card-table">
                                      <div className="card-body">
                                        <div className="table-responsive">
                                          <div
                                            ref={topScrollRef}
                                            className="top-scrollbar"
                                            style={{
                                              overflowX: 'auto',
                                              overflowY: 'hidden',
                                              marginBottom: '10px',
                                              height: '90px'
                                            }}
                                          >
                                            <div className="top-scroll-content" style={{ height: '1px' }}></div>
                                          </div>
                                          <div className="table-responsive production-output-listing" ref={tableContainerRef}>


                                            <MaterialReactTable
                                              columns={columns}
                                              data={data}
                                              rowCount={totalRows}
                                              enablePagination={true}
                                              enableSorting={true}
                                              enableColumnFilters={true}
                                              manualPagination={true}
                                              manualSorting={true}
                                              manualFiltering={true}
                                              state={{
                                                pagination,
                                                isLoading: loading,
                                                sorting,
                                                columnFilters
                                              }}
                                              onPaginationChange={setPagination}
                                              onSortingChange={setSorting}
                                              onColumnFiltersChange={setColumnFilters}
                                              muiTableBodyRowProps={{
                                                sx: { "&:nth-of-type(even)": { backgroundColor: "#f5f5f5" } },
                                              }}
                                              enablePinning={true}
                                              enableRowActions={true}
                                              renderRowActionMenuItems={({ row }) => [
                                                permission?.list === 1 && row.original.total_output_type === 'Finished' && (
                                                  <MenuItem key="view1" onClick={() => printPalletLabel(row.original)}>
                                                    Print Pallet Label

                                                    {isLoadingimg && (
                                                      <img
                                                        id="loader-image2"
                                                        className="loader-image loader-hide"
                                                        src={loader_image}
                                                        alt="Loading"
                                                      />
                                                    )}
                                                  </MenuItem>
                                                ),

                                                permission?.list === 1 && row.original.total_output_type === 'Semi Finished' && (
                                                  <MenuItem key="view2" onClick={() => handleSemiFinishedClick(row.original.id)}>
                                                    Print Pallet Label
                                                  </MenuItem>
                                                ),
                                                permission?.update === 1 && (
                                                  <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                    Edit
                                                  </MenuItem>
                                                ),
                                                permission?.delete === 1 && (
                                                  <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                    Delete
                                                  </MenuItem>
                                                ),
                                              ]}

                                            />
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>

                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductionOutput;
